<script setup lang="ts">
import { pgettext } from '@integro/gettext';
import { ItpLoadingIndicator, ItpLoadError } from '../loading';

type LoadingPlaceholder = 'spinner' | 'none';

withDefaults(
  defineProps<{
    loading?: boolean;
    reloading?: boolean;
    loadingSpinner?: boolean;
    loaded?: boolean;
    renderOnlyWhenLoadCompleted?: boolean;
    error?: Error | string | null;
    loadingPlaceholder?: LoadingPlaceholder;
  }>(),
  {
    loading: false,
    reloading: false,
    loadingSpinner: false,
    loaded: false,
    renderOnlyWhenLoadCompleted: false,
    error: null,
    loadingPlaceholder: 'spinner',
  },
);

const emit = defineEmits<{
  (e: 'reload'): void;
}>();

const msgReloading = pgettext('UserControlMessage', 'Reloading...');
const msgLoading = pgettext('UserControlMessage', 'Loading...');
</script>

<template>
  <div
    class="position-relative"
    :class="{
      'd-flex flex-column h-100':
        !loaded && (loadingPlaceholder === 'spinner' || !!error),
    }"
  >
    <ItpLoadError
      v-if="error && !loaded"
      :error="error"
      :reloading="reloading"
      @reload="emit('reload')"
    />

    <slot v-else-if="loaded || loadingPlaceholder === 'none'" />

    <ItpLoadingIndicator
      v-else-if="loadingPlaceholder === 'spinner'"
      fill
      :text="msgLoading"
    />

    <div
      v-if="error && loaded"
      class="alert alert-danger m-2 py-2 mb-0"
      role="alert"
    >
      {{ reloading ? msgReloading : error }}
    </div>

    <ItpProgressLinear
      v-if="loadingSpinner && loading"
      class="w-100 position-absolute"
      style="top: 0"
    />
  </div>
</template>
